/*
 * Created by kevin tiller on 8/24/2017.
 */
angular.module('flipto.core.enums')
    .constant('confirmationTimerActionTypes', [
        { id: "0", name: 'Proceed to main view after timer expires' },
        { id: "1", name: 'Return to confirmation page after timer expires' }
    ]);